import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSaleProduct,
  fetchSaleProducts,
  fetchSaleProductsSofa,
  createSaleProduct,
  fetchSpecialProducts,
  updateSaleProduct,
  pmUpdateSaleProduct,
  deleteSalteProduct,
} from '../actions/sale-product.action';

const initialState = {
  saleProducts: {
    data: {},
    // isLoading: false,
    // isNeedReloadData: true,
    // limit: 20,
    // offset: 0,
  },
  detail: {
    data: {},
    isLoading: false,
    isNeedReloadData: true,
  },
  createSaleProduct: {
    isLoading: false,
  },
  deleteSaleProduct: {
    isLoading: false,
  },
  updateSaleProduct: {
    isLoading: false,
  },
  updateSaleProductPm: {
    isLoading: false,
  },
  specialProducts: {
    data: [],
    isLoading: false,
    isNeedReloadData: true,
    limit: 20,
    offset: 0,
  },
};

export const saleProductReducer = createSlice({
  name: 'SaleProduct',
  initialState,
  reducers: {
    reloadSaleProducts: (state, action) => {
      const { id } = action.payload || {};
      if (id) {
        const { data: oldData } = state.saleProducts;
        const productData = oldData[id] || {};
        state.saleProducts = {
          ...state.saleProducts,
          data: {
            ...oldData,
            [id]: {
              ...productData,
              isNeedReloadData: true,
            },
          },
        };
      }
    },
    reloadSpecialProducts: state => {
      state.specialProducts = {
        ...state.specialProducts,
        data: [],
        isNeedReloadData: true,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSaleProducts.pending, (state, action) => {
        const { productId } = action.meta.arg;
        const { data: oldData } = state.saleProducts;
        const productData = oldData[productId] || {};
        state.saleProducts = {
          ...state.saleProducts,
          data: {
            ...oldData,
            [productId]: {
              ...productData,
              isLoading: true,
              isNeedReloadData: false,
            },
          },
        };
      })
      .addCase(fetchSaleProducts.rejected, (state, action) => {
        const { productId } = action.meta.arg;
        const { data: oldData } = state.saleProducts;
        const productData = oldData[productId] || {};
        state.saleProducts = {
          ...state.saleProducts,
          data: {
            ...oldData,
            [productId]: {
              ...productData,
              isLoading: false,
            },
          },
        };
      })
      .addCase(fetchSaleProducts.fulfilled, (state, action) => {
        if (action.payload) {
          const {
            data: newData,
            total,
            offset,
            limit,
            productId,
            ...props
          } = action.payload;
          const { data: oldData } = state.saleProducts;
          const productData = oldData[productId] || {};

          if (Number(offset)) {
            if (newData)
              state.saleProducts = {
                ...state.saleProducts,
                data: {
                  ...oldData,
                  [productId]: {
                    ...productData,
                    products: [...(productData.products || []), ...newData],
                    total,
                    offset: offset ?? 0 + productData.limit,
                    limit: limit ?? 10,
                    isLoading: false,
                    ...props,
                  },
                },
              };
          } else {
            state.saleProducts = {
              ...state.saleProducts,
              data: {
                ...oldData,
                [productId]: {
                  ...(productData || {}),
                  products: newData ?? [],
                  total,
                  offset: offset ?? 0 + productData.limit,
                  limit: limit ?? 10,
                  isLoading: false,
                  ...props,
                },
              },
            };
          }
        }
      })
      .addCase(fetchSaleProductsSofa.pending, (state, action) => {
        const { productId } = action.meta.arg;
        const { data: oldData } = state.saleProducts;
        const productData = oldData[productId] || {};

        state.saleProducts = {
          ...state.saleProducts,
          data: {
            ...oldData,
            [productId]: {
              ...productData,
              isLoading: true,
            },
          },
        };
      })
      .addCase(fetchSaleProductsSofa.rejected, (state, action) => {
        const { productId } = action.meta.arg;
        const { data: oldData } = state.saleProducts;
        const productData = oldData[productId] || {};

        state.saleProducts = {
          ...state.saleProducts,
          data: {
            ...oldData,
            [productId]: {
              ...productData,
              isLoading: false,
            },
          },
        };
      })
      .addCase(fetchSaleProductsSofa.fulfilled, (state, action) => {
        if (action.payload) {
          const { data: newData, total, offset, productId } = action.payload;
          const { data: oldData } = state.saleProducts;
          const productData = oldData[productId] || {};
          if (offset) {
            if (newData)
              state.saleProducts = {
                ...state.saleProducts,
                data: {
                  ...oldData,
                  [productId]: {
                    products: [...(productData.products || []), ...newData],
                    total,
                    offset: offset ?? 0 + productData.limit,
                    isLoading: false,
                  },
                },
              };
          } else {
            state.saleProducts = {
              ...state.saleProducts,
              data: {
                ...oldData,
                [productId]: {
                  products: newData ?? [],
                  total,
                  offset: offset ?? 0 + productData.limit,
                  isLoading: false,
                },
              },
            };
          }
        }
      })
      .addCase(fetchSaleProduct.pending, state => {
        state.detail = {
          ...state.detail,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchSaleProduct.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.detail = {
            ...state.detail,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchSaleProduct.rejected, (state, action) => {
        state.detail = { ...state.detail, isLoading: false };
      })
      .addCase(createSaleProduct.pending, state => {
        state.createSaleProduct = {
          ...state.createSaleProduct,
          isLoading: true,
        };
      })
      .addCase(createSaleProduct.fulfilled, (state, action) => {
        state.createSaleProduct = {
          ...state.createSaleProduct,
          isLoading: false,
        };
      })
      .addCase(createSaleProduct.rejected, (state, action) => {
        state.createSaleProduct = {
          ...state.createSaleProduct,
          isLoading: false,
        };
      })
      .addCase(deleteSalteProduct.pending, state => {
        state.deleteSaleProduct = {
          ...state.deleteSaleProduct,
          isLoading: true,
        };
      })
      .addCase(deleteSalteProduct.fulfilled, (state, action) => {
        state.deleteSaleProduct = {
          ...state.deleteSaleProduct,
          isLoading: false,
        };
      })
      .addCase(deleteSalteProduct.rejected, (state, action) => {
        state.deleteSaleProduct = {
          ...state.deleteSaleProduct,
          isLoading: false,
        };
      })
      .addCase(updateSaleProduct.fulfilled, (state, action) => {
        state.updateSaleProduct = {
          ...state.updateSaleProduct,
          isLoading: false,
        };
      })
      .addCase(updateSaleProduct.rejected, (state, action) => {
        state.updateSaleProduct = {
          ...state.updateSaleProduct,
          isLoading: false,
        };
      })
      .addCase(pmUpdateSaleProduct.fulfilled, (state, action) => {
        state.updateSaleProductPm = {
          ...state.updateSaleProductPm,
          isLoading: false,
        };
      })
      .addCase(pmUpdateSaleProduct.rejected, (state, action) => {
        state.updateSaleProductPm = {
          ...state.updateSaleProductPm,
          isLoading: false,
        };
      })
      .addCase(fetchSpecialProducts.pending, state => {
        state.specialProducts = {
          ...state.specialProducts,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchSpecialProducts.fulfilled, (state, action) => {
        if (action.payload) {
          const { data, total, offset } = action.payload;
          let oldData = state.specialProducts.data || [];
          if (offset) {
            state.specialProducts = {
              ...state.specialProducts,
              data: [...oldData, ...data],
              total,
              offset,
              isLoading: false,
            };
          } else {
            state.specialProducts = {
              ...state.specialProducts,
              data: data,
              total,
              offset,
              isLoading: false,
            };
          }
        }
      });
  },
});

export const { reloadSaleProducts, reloadSpecialProducts } =
  saleProductReducer.actions;

export default saleProductReducer.reducer;
